// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: infoProps.helpIcon?.css, // Store Custom Code
            tooltipClickable: css`
                /* Store Custom Code - Removed focusStyles */
                padding: 0;
            `,
            // Store Custom Code - Removed tooltipContainer
        },
        // Store Custom Code - Removed typographyProps
    },
};

export default tooltip;
